import React from "react";
import { getAvatarColor, getInitials } from "../../../utils/avatarUtils";

function QmsVaultStaffAvatar({ name, compact = false, title }) {
  const displayName = String(name || "").trim() || "Unknown";
  const initials = getInitials(displayName);

  return (
    <span
      className={`qms-vault__staff-chip${compact ? " qms-vault__staff-chip--compact" : ""}`}
      title={title || displayName}
    >
      <span
        className="qms-vault__staff-avatar"
        style={{ backgroundColor: getAvatarColor(displayName) }}
        aria-hidden="true"
      >
        {initials}
      </span>
      {!compact && <span className="qms-vault__staff-name">{displayName}</span>}
    </span>
  );
}

export default QmsVaultStaffAvatar;
